import { AxiosError } from 'axios';

// Since these functions return a static value function. We can ignore the code coverage
/* istanbul ignore next */
export function alwaysTrueOp(): boolean {
  return true;
}

/* istanbul ignore next */
// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noop(): void {}

export function parseAxiosError(err: AxiosError<{ name: string; message: string }>): Error {
  return err.response?.data || err;
}
